import React from 'react'
import { Nav, Navbar, Icon } from '@softwaredev_cegeka/stix-core'
import { UserMenu } from '../Menu'
import { NavLink } from 'react-router-dom'
import logo from '../../assets/images/logo-white.png'
// Style
import './header.scss'

const Header = props => {
    return (
        <Navbar
            fixed={'top'}
            sticky={'top'}
            bg={'primary'}
            variant={'dark'}
            expand={'lg'}
        >
            <NavLink to={'/'} className="stix-navbar-brand">
                <img src={logo} alt={'logo'} />
            </NavLink>
            <Navbar.Toggle children={<Icon icon={'menu'} />} />
            <Navbar.Collapse id={'main-nav'}>
                <Nav>
                    <NavLink
                        className="stix-nav-link"
                        activeClassName="active"
                        to={'/users'}
                    >
                        {'Users'}
                    </NavLink>
                    <NavLink
                        className="stix-nav-link"
                        activeClassName="active"
                        to={'/groups'}
                    >
                        {'Groups'}
                    </NavLink>
                    <NavLink
                        className="stix-nav-link"
                        activeClassName="active"
                        to={'/tenants'}
                    >
                        {'Tenants'}
                    </NavLink>
                    {process.env.REACT_APP_ENABLE_SUPPLIER_FUNCTIONALITY ===
                        'true' && (
                        <NavLink
                            className="stix-nav-link"
                            activeClassName="active"
                            to={'/suppliers'}
                        >
                            {'Suppliers'}
                        </NavLink>
                    )}
                    {props.globalAdmin && (
                        <NavLink
                            className="stix-nav-link"
                            activeClassName="active"
                            to={'/services'}
                        >
                            {'Services'}
                        </NavLink>
                    )}
                    <NavLink
                        className="stix-nav-link"
                        activeClassName="active"
                        to={'/applications'}
                    >
                        {'Applications'}
                    </NavLink>
                    <NavLink
                        className="stix-nav-link"
                        activeClassName="active"
                        to={'/user_sessions'}
                    >
                        {'User Sessions'}
                    </NavLink>
                </Nav>
            </Navbar.Collapse>
            <Navbar.Right>
                <UserMenu />
            </Navbar.Right>
        </Navbar>
    )
}

export default Header
